// extracted by mini-css-extract-plugin
export default {"card":"ResultPayPayroll_card__kDnT2","notice":"ResultPayPayroll_notice__mZyFo","buttons":"ResultPayPayroll_buttons__1VKkr","color":"ResultPayPayroll_color__6GUEc"};